import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Area, AreaChart, ResponsiveContainer } from 'recharts';
import COLORS from '../../../util/constants/colors';
import { formatCount, formatRangeLabel } from './helpers';

const METRICS = [
  { key: 'worked', label: 'Records worked', color: COLORS.PURPLE_PRIMARY_LITE },
  { key: 'sent_to_chart', label: 'Sent to chart', color: '#4f8a8b' },
  { key: 'archived', label: 'Archived', color: '#5f9e6e' },
  { key: 'merged', label: 'Merged', color: '#b9975b' },
];

const InboxActivity = ({ inbox }) => (
  <div className="user-activity-card user-activity-inbox">
    <div className="user-activity-section-header">
      <div>
        <h3>Inbox activity</h3>
        <span className="user-activity-caption">
          {inbox.filtered ? 'Selected team members · all record types' : 'Team + automation · all record types'}
        </span>
      </div>
      <span className="user-activity-caption">
        {formatRangeLabel({ startDate: inbox.date_range.start_date, endDate: inbox.date_range.end_date })}
      </span>
    </div>
    <div className="user-activity-inbox-metrics">
      {METRICS.map(({ key, label, color }) => (
        <div key={key} className="user-activity-inbox-metric">
          <span className="user-activity-caption">{label}</span>
          <span className="user-activity-inbox-value" style={{ color }}>{formatCount(inbox.metrics[key].total)}</span>
          <ResponsiveContainer width="100%" height={40}>
            <AreaChart data={inbox.metrics[key].daily}>
              <Area
                type="monotone"
                dataKey="count"
                stroke={color}
                fill={color}
                fillOpacity={0.08}
                isAnimationActive={false}
              />
            </AreaChart>
          </ResponsiveContainer>
        </div>
      ))}
    </div>
    <div className="user-activity-inbox-footer">
      <span className="user-activity-footnote">Unique records per activity · counts can overlap</span>
      <div className="user-activity-inbox-now">
        <strong>Inbox now</strong>
        <span className="user-activity-caption">faxes and emails</span>
        <span>
          <strong>{formatCount(inbox.inbox_now.remaining)}</strong>
          {' remaining'}
        </span>
        <span>
          <strong>{formatCount(inbox.inbox_now.unread)}</strong>
          {' unread'}
        </span>
        <span>
          <strong>{formatCount(inbox.inbox_now.unassigned)}</strong>
          {' unassigned'}
        </span>
      </div>
    </div>
    {inbox.audit_history_starts_at && (
      <span className="user-activity-footnote">
        {`Worked, archived and merged only include activity from ${moment(inbox.audit_history_starts_at).format('MMM D, YYYY')} on`}
      </span>
    )}
  </div>
);

InboxActivity.propTypes = {
  inbox: PropTypes.shape({
    filtered: PropTypes.bool,
    date_range: PropTypes.object.isRequired,
    metrics: PropTypes.object.isRequired,
    inbox_now: PropTypes.object.isRequired,
    audit_history_starts_at: PropTypes.string,
  }).isRequired,
};

export default InboxActivity;
